// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mlm-main-container {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  position: relative;
}

.mlm-bg-img-div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  overflow: hidden;
}


.padding-layout {
  padding: 1rem 1rem 4rem 1rem;
}

.mlm-main-grid-container {
  position: relative;
}

.glow-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.2;
}

.mlm-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.mlm-grid-container {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  padding: 2rem 0 2rem 0;
}

.mlm-grid-card {
  width: auto;
  background-color: #8084FF;
  padding: 2rem 1rem 2rem 1rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.mlm-content {
  text-align: center;
  margin-top: 2rem;
}

.mlm-content .mlm-title {
  font-size: 16px;
  margin-top: 0.5rem;
  color: white;
}

.mlm-content .mlm-desc {
  font-size: 14px;
  margin-top: 0.5rem;
}

.mlm-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #0000009b;
  transform: translateX(-100%);
  transition: transform 0.4s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  padding: 1rem;
  text-align: center;
  backdrop-filter: blur(3px);
}

.mlm-overlay .mlm-title {
  transform: translateY(-50px);
  opacity: 0;
  transition: all 0.4s ease-in-out;
  margin-bottom: 1rem;
  font-size: 18px;
  color: white;
}

.mlm-overlay .mlm-desc {
  transform: translateX(50px);
  opacity: 0;
  transition: all 0.4s ease-in-out;
  font-size: 14px;
}

.mlm-grid-card:hover .mlm-overlay {
  transform: translateX(0);
}

.mlm-grid-card:hover .mlm-overlay .mlm-title {
  transform: translateY(0);
  opacity: 1;
}

.mlm-grid-card:hover .mlm-overlay .mlm-desc {
  transform: translateX(0);
  opacity: 1;
  transition-delay: 0.1s;
}

.mlm-img-div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.mlm-img-div img {
  width: 70px;
  height: 70px;
}

.mlm-startegy-details {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
}

.mlm-startegy-card-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  padding: 2rem 0 2rem 0;
}

.mlm-startegy-container {
  width: 100%;
  height: 100%;
}

.mlm-startegy-card {
  width: 100%;
  height: 100%;
  border: 4px dashed gray;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

@media (min-width: 640px) {
  .mlm-grid-container {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  }
  .mlm-startegy-card-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
    gap: 1rem;
    padding: 2rem 0 2rem 0;
  }
}

@media (min-width: 1280px) {
  .mlm-main-container {
    flex-direction: row;
  }
  .padding-layout {
    padding: 5rem 2rem 5rem 2rem;
  }
}

@media (min-width: 1536px) {
  .padding-layout {
    padding: 4rem 8rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/mlm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,gBAAgB;AAClB;;;AAGA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,UAAU;EACV,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE;IACE,2DAA2D;EAC7D;EACA;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".mlm-main-container {\n  display: flex;\n  flex-direction: column-reverse;\n  justify-content: center;\n  align-items: center;\n  gap: 1rem;\n  position: relative;\n}\n\n.mlm-bg-img-div {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  overflow: hidden;\n}\n\n\n.padding-layout {\n  padding: 1rem 1rem 4rem 1rem;\n}\n\n.mlm-main-grid-container {\n  position: relative;\n}\n\n.glow-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0.2;\n}\n\n.mlm-details {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.mlm-grid-container {\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 2rem;\n  padding: 2rem 0 2rem 0;\n}\n\n.mlm-grid-card {\n  width: auto;\n  background-color: #8084FF;\n  padding: 2rem 1rem 2rem 1rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.mlm-content {\n  text-align: center;\n  margin-top: 2rem;\n}\n\n.mlm-content .mlm-title {\n  font-size: 16px;\n  margin-top: 0.5rem;\n  color: white;\n}\n\n.mlm-content .mlm-desc {\n  font-size: 14px;\n  margin-top: 0.5rem;\n}\n\n.mlm-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #0000009b;\n  transform: translateX(-100%);\n  transition: transform 0.4s ease-in-out;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  padding: 1rem;\n  text-align: center;\n  backdrop-filter: blur(3px);\n}\n\n.mlm-overlay .mlm-title {\n  transform: translateY(-50px);\n  opacity: 0;\n  transition: all 0.4s ease-in-out;\n  margin-bottom: 1rem;\n  font-size: 18px;\n  color: white;\n}\n\n.mlm-overlay .mlm-desc {\n  transform: translateX(50px);\n  opacity: 0;\n  transition: all 0.4s ease-in-out;\n  font-size: 14px;\n}\n\n.mlm-grid-card:hover .mlm-overlay {\n  transform: translateX(0);\n}\n\n.mlm-grid-card:hover .mlm-overlay .mlm-title {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.mlm-grid-card:hover .mlm-overlay .mlm-desc {\n  transform: translateX(0);\n  opacity: 1;\n  transition-delay: 0.1s;\n}\n\n.mlm-img-div {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n.mlm-img-div img {\n  width: 70px;\n  height: 70px;\n}\n\n.mlm-startegy-details {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.mlm-startegy-card-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  padding: 2rem 0 2rem 0;\n}\n\n.mlm-startegy-container {\n  width: 100%;\n  height: 100%;\n}\n\n.mlm-startegy-card {\n  width: 100%;\n  height: 100%;\n  border: 4px dashed gray;\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n@media (min-width: 640px) {\n  .mlm-grid-container {\n    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  }\n  .mlm-startegy-card-container {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));\n    gap: 1rem;\n    padding: 2rem 0 2rem 0;\n  }\n}\n\n@media (min-width: 1280px) {\n  .mlm-main-container {\n    flex-direction: row;\n  }\n  .padding-layout {\n    padding: 5rem 2rem 5rem 2rem;\n  }\n}\n\n@media (min-width: 1536px) {\n  .padding-layout {\n    padding: 4rem 8rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
